import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const StatusPill = dynamic(() => import('./StatusPill'), { ssr: false });

export const defaultOptions = {
	text: 'Status: Accepting New Cases',
	backgroundColor: 'rgba(249, 250, 251, 1)',
} as const;

Builder.registerComponent(StatusPill, {
	name: 'StatusPill',
	inputs: [
		{
			name: 'text',
			type: 'string',
			required: true,
			defaultValue: defaultOptions.text,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			required: true,
			defaultValue: defaultOptions.backgroundColor,
		},
	],
	image: getIconUrl(Icon.COLUMNS),
});
